<template>
<section class="dashboard-view">
  <div class="grid-container">
    <div class="grid-x grid-margin-x">

      <div class="cell small-12 large-12 margin-top-1">
        <div class="banner-carousel" style="height: 275px;">
          <div class="banner-content grid-x grid-margin-x align-middle">

            <div class="cell show-for-medium medium-4 banner__image">
              <img src="/images/support.png" alt="Person using laptop" />
            </div>

            <div class="cell small-12 medium-8 banner__copy">

              <h1 class="white">
                {{
                  currentMilestoneDef?.displayName
                    ? currentMilestoneDef.displayName
                    : (milestoneProgress.currentMilestoneName
                        ? splitByCapitals(milestoneProgress.currentMilestoneName)
                        : "")
                }}
              </h1>

              <h3 class="white" v-if="!(milestoneProgress.totalMilestoneCount === milestoneProgress.numberOfMilestonesComplete)">
                Due: {{ formattedDueDate }}
              </h3>

              <p class="white margin-top-1" v-if="currentMilestoneDef?.description">
                {{ currentMilestoneDef.description }}
              </p>

              <p class="white margin-top-1" v-else>
                You’re making good progress. Let’s try to get the next set of tasks completed by {{ formattedDueDate }}, so that we can go live with your payroll as planned.
              </p>

            </div>
          </div>
        </div>
      </div>

      <!-- MAIN -->
      <div class="cell small-12 large-12 margin-top-2">
        <h1>Your project timeline</h1>
        <br/>
      </div>

      <div class="cell small-12 large-12">
        <VerticalTimeline :items="projectItems" />
      </div>

    </div>
  </div>
</section>
</template>



<script setup>

import { ref, onMounted, computed } from 'vue'

import { useClientStore } from '@/stores/client'
import { getProjectByClientId } from '@/services/implementationmanagement.api.js'
import { useIdentityStore } from '@/stores/identity'

import {
  getMilestoneProgress,
  getMilestoneDefinition
} from '@/helpers/milestones/milestone.js'

import { splitByCapitals } from '@/helpers/strings'

import VerticalTimeline from '@/components/controls/Timeline.vue'


const projectError = 'Sorry, we\'ve been unable to load your project. Please contact your Qtac account manager.'

const milestoneProgress = ref({
  totalMilestoneCount: 0,
  numberOfMilestonesComplete: 0,
  currentMilestoneName: null,
  currentMilestoneDueDate: null
})

const projectItems = ref([])
const identity = useIdentityStore()
const error = ref(null)


const currentMilestoneDef = computed(() => {
  return getMilestoneDefinition(milestoneProgress.value.currentMilestoneName)
})


const formattedDueDate = computed(() => {
  const date = milestoneProgress.value.currentMilestoneDueDate
  if (!date) return ""

  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
})


onMounted(async () => {

  try {

    const client = useClientStore()

    const projectResponse = await getProjectByClientId(client.clientId)

    milestoneProgress.value = await getMilestoneProgress(projectResponse?.data)

    const items = await buildProjectItems(projectResponse?.data?.milestones)

    projectItems.value = items

  } catch (err) {
    error.value = projectError
    console.error(err)
  }

})



async function buildProjectItems(milestones) {

  if (!Array.isArray(milestones)) return []

  const EMPTY_DATE = "0001-01-01T00:00:00"

  return milestones
    .map((m) => {

      const definition = getMilestoneDefinition(m.type)

      // Respect client visibility flag
      if (definition) {
        if(definition.visibleToClient === false && identity.type == "Direct") return null
        if(definition.visibleToIntermediary === false && identity.type == "Intermediary") return null
      }

      const isCompleted = m.completed && m.completed !== EMPTY_DATE
      const isCurrent = m.isCurrent === true

      let status = "inprogress"

      if (isCompleted) status = "completed"
      else if (isCurrent) status = "current"

      return {
        title: definition?.displayName ?? splitByCapitals(m.type),
        status,
        completedAt: isCompleted ? m.completed : undefined,
        dueAt: !isCompleted ? m.scheduledCompletion : undefined,
        description: definition?.description ?? ""
      }

    })
    .filter(Boolean)

}

</script>